const getStatusByCode = state => code => {
  return state.statuses.find(v => v.code === code) || null;
};

const getters = {
  getStatusByCode
};

export default getters;
